import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fade, makeStyles } from '@material-ui/core/styles';
import { Table, InputBase, Button, CircularProgress, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Tooltip, IconButton, FormControl, Input, InputLabel, MenuItem, Select } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import { Edit, VisibilitySharp } from '@material-ui/icons';
import { GlobalContext } from "../../context/GlobalState";
import FormRender from '../../common/FormHelper/FormRender';
import UpdateOrderJson from './Schema/updateOrder.json';
import { DEFAULT_JSON, isValidatedForm } from '../../common/FormHelper/FormValidSetter';
import checkValidity from '../../common/FormHelper/FieldValidator';
import ViewOrderDetails from './ViewOrderDetails';
import Snackbar from "../../common/Snackbar";
import moment from "moment";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'student', label: 'Student' },
  { id: 'centerCode', label: 'Centre Code' },
  { id: 'name', disablePadding: true, label: 'Order Details' },
  { id: 'price', label: 'Price'},
  { id: 'status', label: 'Status' },
  { id: 'order_date', label: 'Order Date' },
  { id: 'dispatch_date', numeric: false, label: 'Dispatch Date' },
  { id: 'action', label: 'Action' }
];

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">

        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'center' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto"
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit",
    border: '1px solid #dddd',
    margin: '6px 6px 0px 6px',
    borderRadius: '6px'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch"
      }
    }
  },
  tbrow: {
    '&:nth-of-type(odd)': {
      backgroundColor: "#faebd761",
    },
    "&:hover": {
      boxShadow: "0px 2px 5px lightsteelblue",
    },
  }
}));

export default function AllOrders() {
  const [selectedStatusType, setSelectedStatusType] = useState("Ordered");
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('name');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [onpayment, setPayment] = React.useState(false)
  const [spinner, setSpinner] = React.useState(true);
  const [newdata1, setNewdata1] = React.useState({})
  const [addInventory, setAddInventory] = React.useState(false);
  const [editingInventory, setEditingInventory] = React.useState(false);
  const [updatingPayment, setUpdatingPayment] = React.useState(false);
  const { allOrder, getOrderDetails } = React.useContext(GlobalContext);
  const {updatedOrderDetails, updateOrderDetails, encodeDecodeString} = React.useContext(GlobalContext);
  const [updatingStatus, setUpdatingStatus] = React.useState(false);
  const [updateOrderJson, setUpdateOrderJson] = React.useState([]);
  const [openOrderDetails, setOpenOrderDetails] = React.useState(false);
  const [viewOrderDetails, setViewOrderDetails] = React.useState({});
  const isAdmin = encodeDecodeString(window.localStorage.getItem("user"),'decode');
  React.useEffect(() => {
    setData(allOrder);
    setTimeout(() => setSpinner(false), 2500)
  }, [allOrder]);

  React.useEffect(() => {
    let searched = allOrder.filter(
      row =>
      row.student_id?.name?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
      row.student_id?.centerCode?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
      row.status?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
      row.inventory.some(std =>
        std.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      )
    );

    if (searchTerm === "") {
      getOrderDetails(selectedStatusType);
      setData(searched);
    } else {
      setData(searched);
    }
  }, [searchTerm]);

  const handleSearch = event => {
    setSearchTerm(event.target.value);
  };

  const InPerson = ["Dunzo", "Rapido", "Porter", "Swiggy", "By Hand", "Others"];
  const Companies = ["Delhivery", "Fedex", "BlueDart", "ShadowFax", "XpressBees", "DTDC", "EKart", "Udaan", "Gati", "AmazonLogistics"];

  const editRecord = (e, id) => {
    var data1 = allOrder.filter(item => item._id === id)
    setNewdata1({ ...data1[0], fromListing: true })
    setUpdateOrderJson(DEFAULT_JSON(JSON.parse(JSON.stringify(UpdateOrderJson))))
    setEditingInventory(true)
    setUpdatingStatus(true)
  };

  const viewOrder = (e, id) => {
    setViewOrderDetails(allOrder.filter(item => item._id === id)[0]);
    setOpenOrderDetails(true);
  };


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = allOrder.map((n) => n.user.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const goToAddInventory = () => {
    setAddInventory(true);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filterOrders = (ev) => {
    const { value } = ev.target;
    setSpinner(true);
    setSelectedStatusType(value);
    getOrderDetails(value);
  }

  const onChangeUpdateOrder = (e, index) => {
    const copyData = JSON.parse(JSON.stringify(updateOrderJson));
    const updatedElement = copyData[index];
    if (updatedElement.name === 'delivery_method') {
      const pgIndex = copyData.findIndex(item => item.name === "courier_company")
      if (e.target.value === 'Courier') {
        copyData[pgIndex]['options'] = Companies;
      } else {
        copyData[pgIndex]['options'] = InPerson;
      }
    }
    
    copyData[2].maxValue = moment().format('yyyy-MM-DD');
    copyData[index].value = e.target.value;
    const { isValid, errorText } = checkValidity(copyData.value,copyData.validation);
    copyData[index].valid = isValid;
    copyData[index].errorText = errorText;
    copyData[index].touched = 1;
    setUpdateOrderJson(copyData);
  }
  const handleClose = () => {
    setUpdateOrderJson(DEFAULT_JSON(JSON.parse(JSON.stringify(UpdateOrderJson))))
    setUpdatingStatus(false)
  }
  const updateOrder = () => {
    const updateOrder = isValidatedForm(JSON.parse(JSON.stringify(updateOrderJson)));
    setUpdateOrderJson(updateOrder.validatedForm)
    if(updateOrder?.formValidity) {
      setUpdatingStatus(false)
      const data = {}
      updateOrder.validatedForm.forEach(
        item => data[item.name] = item.value
      );
      // console.log("Update order api call: ", updateOrder.validatedForm.map(item => ({ [`${item.name}`]: item.value })))
      data.order_id = newdata1._id
      updateOrderDetails(data)
      setTimeout(() => {
        getOrderDetails(selectedStatusType);
      }, 2000);
    }
  }

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, allOrder.length - page * rowsPerPage);

  if (openOrderDetails) {
    return <ViewOrderDetails orderDetails={viewOrderDetails} />
  }
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.search} style={{ display: "inline-block" }}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "search" }}
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
        <div style={{ float: "right", marginRight: "36px", marginTop: "14px", width: "150px" }}>
          <FormControl fullWidth>
            <InputLabel style={{fontSize: "15px"}} id="class-status-label">Select status</InputLabel>
            <Select style={{fontSize: "13px"}}
              labelId="class-status-label"
              id="class-status"
              value={selectedStatusType || 'Ordered'}
              onChange={filterOrders}
              input={<Input />}
            >
              <MenuItem value="Ordered">Ordered</MenuItem>
              <MenuItem value="Dispatched">Dispatched</MenuItem>
            </Select>
          </FormControl>
        </div>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={allOrder.length}
            />

            {spinner ? (
              <TableBody style={{ position: "relative" }}>
                <TableRow>
                  <TableCell>
                    <CircularProgress
                      style={{ padding: "5px", position: "absolute", left: "50%" }}
                      color="primary"
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
                <TableBody>
                  {stableSort(data, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const filteredProgram = row?.inventory;
                      let num = "";
                      let programNum = "";
                      if (filteredProgram?.length > 1) {
                        num = ` +${filteredProgram?.length - 1}`
                        let programs = new Set(filteredProgram.map(item => item.name))
                        programs = [...programs]
                        if (programs.length > 1) {
                          programNum = ` +${programs.length - 1}`
                        }
                      }
                      return (
                        <TableRow
                          className={classes.tbrow}
                          key={row._id}
                          style={{ cursor: "pointer" }}
                          hover>
                          <TableCell padding="checkbox"></TableCell>
                          <TableCell>{row.student_id?.name}</TableCell>
                          <TableCell>{row.student_id?.centerCode}</TableCell>
                          <TableCell>{row?.inventory.length > 0 ? row?.inventory[0].name + programNum : row.inventory.name}</TableCell>
                          <TableCell>{row.total_cost}</TableCell>
                          <TableCell>{row.status}</TableCell>
                          <TableCell>{row?.order_date?.length ? moment(row.order_date.toString()).format("DD/MM/YYYY HH:mm") : '-'}</TableCell>
                          <TableCell>{row?.dispatch_date?.length ? moment(row.dispatch_date.toString()).format("DD/MM/YYYY") : '-'}</TableCell>
                          <TableCell>
                          {row.status !== 'Dispatched' &&
                            <Tooltip title="Update Status" arrow>
                              <IconButton disabled={isAdmin === 'marketing'} className="bg5" onClick={e => editRecord(e.currentTarget.value, row._id)} >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                          }
                            <Tooltip title="View Order" arrow>
                              <IconButton className="bg5" onClick={e => viewOrder(e.currentTarget.value, row._id)} >
                                <VisibilitySharp />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              )}
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 75, 100, 500]}
          component="div"
          count={allOrder.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <Dialog
        id="popup"
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        open={updatingStatus}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title-new-faculty'
        fullWidth={true}
      >
        <DialogTitle
          align='center'
          style={{ background: "antiquewhite" }}
          id='responsive-dialog-title-new-faculty'
        >
          Update Order Status
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <FormRender
            form={updateOrderJson}
            onChange={onChangeUpdateOrder}
          />
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button onClick={() => updateOrder()} variant='contained' color="primary">
            Update
          </Button>
          <Button onClick={() => handleClose()} variant='contained' color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      {updatedOrderDetails ? <Snackbar key={updatedOrderDetails} status="success" msg={updatedOrderDetails} /> : null}
    </div>
  );
}